import { createApi } from '@reduxjs/toolkit/query/react'
import appConfig from 'configs/app.config'
import BaseService from 'services/BaseService'

const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: '' }) =>
    async ({ url, method, data, params, headers }) => {
        try {
            const result = await BaseService({
                url: baseUrl + url,
                method,
                data,
                params,
                headers,
            })
            return { data: result.data }
        } catch (axiosError) {
            const err = axiosError
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            }
        }
    }

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: axiosBaseQuery({ baseUrl: appConfig.apiPrefix }),
    tagTypes: ['POST', 'HOUSES_DETAIL_POST'],
    endpoints: () => ({}),
})
